import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import { createRxValue, WithOptional } from "@app/_helpers/utils";
import { MaterialScale } from "@app/animations/fade";
import { WorkspaceGroup } from "@timeghost/web-api";

type Group = WorkspaceGroup & { users: { id: string; name: string; email: string }[] };
@Component({
	selector: "tg-user-group-view",
	templateUrl: "./user-group-view.component.html",
	styleUrls: ["./user-group-view.component.scss"],
	animations: [MaterialScale],
})
export class UserGroupViewComponent implements OnInit {
	@Input()
	group: WithOptional<Group>;
	@Input()
	showGroupUsers: boolean;
	@Input()
	showDelete: boolean;
	@Input()
	deleteEntityTemplate: TemplateRef<any>;
	@Input()
	groupUsersTemplate: TemplateRef<any>;

	showUsers = createRxValue(false);
	constructor() {}
	toggleUsersView() {
		this.showUsers.value = !this.showUsers.value;
	}
	trackId(_: number, { id }: { id: string }) {
		return id;
	}
	ngOnInit(): void {}
}
